module.exports = __webpack_public_path__ + "static/img/20.dc47f403.jpg";